import type { SVGProps } from 'react';
const SvgVisible = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M8 3.923c-2.435-.041-4.954 1.66-6.538 3.403a1.005 1.005 0 0 0 0 1.345c1.55 1.707 4.06 3.448 6.538 3.406 2.477.042 4.99-1.7 6.54-3.406a1.005 1.005 0 0 0 0-1.345C12.954 5.583 10.435 3.882 8 3.923"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
    <path
      d="M10.266 8A2.266 2.266 0 1 1 5.735 8a2.266 2.266 0 0 1 4.53.001"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgVisible;
